module.exports = __webpack_public_path__ + "img/new-step14.378b50c9.jpg";